import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getServiceTypes,
  serviceTypeListSuccessful,
  serviceTypeAddSuccessful,
  isModelVisible,
} from "./serviceTypeSlice";

import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
} from "react-icons/ri";

function* getServiceTypeList({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/servicetypes/", params);
    yield put(serviceTypeListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddServiceType({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/servicetypes/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (<span className="remix-icon"><RiCheckboxCircleLine /></span>),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (<div><p className="hp-p1-body hp-text-color-black-80">Your Service Type Add Successfully.!</p></div>),
        });
        yield put(getServiceTypes({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (<span className="remix-icon"><RiAlertLine /></span>),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (<div><p className="hp-p1-body hp-text-color-black-80">Sorry! Unable to added Service Type. Please try again!</p></div>),
        });
      }
    } else {
      const response = yield call(postEdit, "/masters/servicetypes/" + payload.id, payload);
      if (response.status === 200) {
        Modal.success({
          icon: (<span className="remix-icon"><RiCheckboxCircleLine /></span>),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (<div><p className="hp-p1-body hp-text-color-black-80">Your Service Type Edited Successfully.!</p></div>),
        });
        yield put(getServiceTypes({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (<span className="remix-icon"><RiAlertLine /></span>),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (<div><p className="hp-p1-body hp-text-color-black-80">Sorry! Unable to edit Service Type. Please try again!</p></div>),
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: (<span className="remix-icon"><RiAlertLine /></span>),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (<div><p className="hp-p1-body hp-text-color-black-80">Sorry! Getting from server side issue!</p></div>),
    });
    yield put(apiError(error));
  }
}

function* DeleteServiceType({ payload }) {
  var id = payload;
  try {
    const response = yield call(postDelete, "/masters/servicetypes/" + id);
    if (response.status === 204) {
      Modal.success({
        icon: (<span className="remix-icon"><RiCheckboxCircleLine /></span>),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (<div><p className="hp-p1-body hp-text-color-black-80">Your Service Type Deleted Successfully.!</p></div>),
      });
      yield put(getServiceTypes({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (<span className="remix-icon"><RiAlertLine /></span>),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (<div><p className="hp-p1-body hp-text-color-black-80">Sorry! Unable to delete Service Type. Please try again!</p></div>),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (<span className="remix-icon"><RiAlertLine /></span>),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (<div><p className="hp-p1-body hp-text-color-black-80">Sorry! Getting from server side issue!</p></div>),
    });
    yield put(apiError(error));
  }
}

export function* watchGetServiceTypes() {
  yield takeEvery("serviceType/getServiceTypes", getServiceTypeList);
}
export function* watchServiceTypeAdd() {
  yield takeEvery("serviceType/serviceTypeAdd", AddServiceType);
}
export function* watchServiceTypeDelete() {
  yield takeEvery("serviceType/serviceTypeDelete", DeleteServiceType);
}

function* serviceTypeSaga() {
  yield all([
    fork(watchGetServiceTypes),
    fork(watchServiceTypeAdd),
    fork(watchServiceTypeDelete),
  ]);
}

export default serviceTypeSaga;
